module.exports = __webpack_public_path__ + "img/hr-logo-color.1a086676.png";